import AdminPanelFormsListPage from './container';

export default AdminPanelFormsListPage;
